/* Perry Spices top bar rotator (Oct 9).
   Splits the top bar text (Theme settings > Top bar > Text 2) on "•" and shows one message at a time.
   Gritty pt 48 (Nov 2, 2026): two clickable holiday offers lead the rotation:
   "Holiday gifts from $22" (Holiday Gift Guide) and "4 blends for $42 + free shipping" (Flavor Starter Pack).
   To remove them later, empty the PROMOS list below. */
(function(){
  var PROMOS = [
    { text: '🎁 HOLIDAY GIFTS FROM $22 → SHOP MINIS', href: '/collections/holiday-gift-guide' },
    { text: '4 BLENDS FOR $42 + FREE SHIPPING', href: '/products/flavor-starter-pack' }
  ];
  function init(){
    var p = document.querySelector('.dt-sc-header-top-bar .top-bar-text2');
    if (!p || p.dataset.psRot) return;
    var base = p.textContent.split('•').map(function(s){ return s.trim(); }).filter(Boolean).map(function(t){ return { text: t }; });
    var items = PROMOS.concat(base);
    if (items.length < 2) return;
    p.dataset.psRot = '1';
    p.classList.add('ps-rot-on');
    p.setAttribute('aria-label', items.map(function(x){ return x.text; }).join(', '));
    p.innerHTML = '';
    var wrap = document.createElement('span'); wrap.className = 'ps-rot';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'ps-rot__btn'; prev.setAttribute('aria-label', 'Previous message'); prev.textContent = '<';
    var msg = document.createElement('span'); msg.className = 'ps-rot__msg'; msg.setAttribute('aria-live', 'off');
    var next = document.createElement('button'); next.type = 'button'; next.className = 'ps-rot__btn'; next.setAttribute('aria-label', 'Next message'); next.textContent = '>';
    wrap.appendChild(prev); wrap.appendChild(msg); wrap.appendChild(next); p.appendChild(wrap);
    var i = 0, timer = null, still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function paint(it){
      msg.textContent = '';
      if (it.href){
        var a = document.createElement('a'); a.href = it.href; a.textContent = it.text;
        a.style.color = 'inherit'; a.style.textDecoration = 'underline'; a.style.textUnderlineOffset = '3px';
        msg.appendChild(a);
      } else { msg.textContent = it.text; }
    }
    function show(n){
      i = (n + items.length) % items.length;
      if (still){ paint(items[i]); return; }
      msg.classList.add('is-out');
      setTimeout(function(){ paint(items[i]); msg.classList.remove('is-out'); }, 250);
    }
    function start(){ stop(); timer = setInterval(function(){ show(i + 1); }, 3500); }
    function stop(){ if (timer) clearInterval(timer); timer = null; }
    paint(items[0]);
    prev.addEventListener('click', function(){ show(i - 1); start(); });
    next.addEventListener('click', function(){ show(i + 1); start(); });
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
